var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"re-loading",class:_vm.loaderClasses},[(_vm.$slots.default || _vm.$$trim(_vm.loadingMessage))?_c('div',{staticClass:"re-loading-message"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.loadingMessage))]})],2):_vm._e(),(_vm.withLoader)?_c('div',{staticClass:"with-loader"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }